// Query hook (simple) - lista ofert klienta dla modali typu "Przypnij oferte do transakcji".
// GET /api/ui/sales-crm/clients/{clientId}/offers?page=1&limit=200
//
// Nazwa "Simple" zeby nie kolidowac z istniejacym `WiseTable`-based fetch'em w
// TraderPanelClientOffers.tsx (ten ma bogata konfiguracje filtrow, kolumn, paginacji).

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ITraderClientOfferLite {
  id: number;
  number?: string | null;
  status?: number | null;
  clientId?: number | null;
  dealId?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface IGetTraderClientOffersResponse {
  page?: number;
  limit?: number;
  totalCount?: number;
  items: ITraderClientOfferLite[];
}

const getTraderClientOffers = (clientId: number): Promise<IGetTraderClientOffersResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/offers`, {
    params: { page: 1, limit: 200 },
  });

export const useGetTraderClientOffersSimple = (
  clientId: number,
  options?: UseQueryOptions<IGetTraderClientOffersResponse, IError>,
) =>
  useQuery<IGetTraderClientOffersResponse, IError>(
    ['sales-crm-trader-client-offers-simple', clientId],
    () => getTraderClientOffers(clientId),
    {
      enabled: clientId > 0,
      ...options,
    },
  );
